import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'filterTecnico',
  components: {Multiselect},
  props: [],
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      form: {
        dataInclusaoInicio: null,
        dataInclusaoFim: null,
        nome: null,
        listagemInterna: [],
        dataUltimaAtualização: null
      },
      listagem: [{nome: 'ENGENHEIRO', tipo: 0}, {nome: 'TECNICO', tipo: 1}]
    }
  },
  watch: {
    'form.dataInclusaoInicio' (value) {
      if (this.form.dataInclusaoFim != null) {
        if (this.form.dataInclusaoInicio > this.form.dataInclusaoFim) {
          this.form.dataInclusaoFim = null
          toast.warning('A date Desde deve ser menor que a data Até')
        }
      }
    },
    'form.dataInclusaoFim' (value) {
      if (this.form.dataInclusaoInicio != null) {
        if (this.form.dataInclusaoInicio > this.form.dataInclusaoFim) {
          this.form.dataInclusaoInicio = null
          toast.warning('A date Desde deve ser menor que a data Até')
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    Search () {
      this.$emit('search', {DataInclusaoInicio: this.form.dataInclusaoInicio, DataInclusaoFim: this.form.dataInclusaoFim, Categoria: this.form.listagemInterna, Nome: this.form.nome, TipoFluxo: this.tipoFluxo, Limpar: false})
    },
    SearchLimpar () {
      this.$emit('search', {DataInclusaoInicio: this.form.dataInclusaoInicio, DataInclusaoFim: this.form.dataInclusaoFim, Categoria: this.form.listagemInterna, Nome: this.form.nome, TipoFluxo: this.tipoFluxo, Limpar: true})
    },
    onClearSection () {
      this.form.dataInclusaoInicio = null
      this.form.dataInclusaoFim = null
      this.form.nome = null
      this.form.listagemInterna = []
      this.SearchLimpar()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/occurrenceMaintenance/components/filter/filter.js